import request from '@/utils/request';

// 获取店铺默认配置
export function getMerchantDefaultConfig() {
  return request({
    url: '/admin/merchant/store/default/config/get',
    method: 'get'
  });
}

// 保存或更新店铺默认配置
export function saveMerchantDefaultConfig(data) {
  return request({
    url: '/admin/merchant/store/default/config/save',
    method: 'post',
    data: data
  });
}